<template>
  <v-form ref="CHECK_DELIVERY" @submit.prevent="sectionSave" lazy-validation>
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CHECK_DELIVERY">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <etablissement-select v-if="isDisplayed('ETABLISSEMENT_ID')"
                              ref="ETABLISSEMENT_ID"
                              :theme="theme"
                              :showMissing="showMissing"
                              v-model=etablissementId
                              :moduleId=moduleId
                              libelle="'Emetteur'"
                              newLabel=''
                              selectText=""
                              @status=statusEtablissementId
                              :ressource=ressourceEtablissementSelect
                              :filters=etablissementIdFilter
                              :toggleReset=resetEtablissementId
                              :required="isRequired('ETABLISSEMENT_ID')"
                              :contextId=transaction.id
                              :readOnly="readOnly('ETABLISSEMENT_ID')"
                              :objType=objType
                              :sectionName="sectionName">
        </etablissement-select>
        <transaction-amount v-if="isDisplayed('AMOUNT')"
                            ref="AMOUNT"
                            :theme="theme"
                            :showMissing="showMissing"
                            v-model=amount
                            @status=statusAmount
                            :required="isRequired('AMOUNT')"
                            :contextId=transaction.id
                            :readOnly="readOnly('AMOUNT')"
                            :objType=objType
                            :sectionName="sectionName">
        </transaction-amount>
        <transaction-reference v-if="isDisplayed('REFERENCE')"
                               ref="REFERENCE"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model=reference
                               @status=statusReference
                               :required="isRequired('REFERENCE')"
                               :contextId=transaction.id
                               :readOnly="readOnly('REFERENCE')"
                               :objType=objType
                               :sectionName="sectionName">
        </transaction-reference>
        <v-file-input v-model="file"
                      :disabled="progress"
                      :accept="acceptedFiles"
                      :error="fileError"
                      :label="fileInputLabel">
        </v-file-input>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!scanned">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :label="button.label"
                       :disabled="button.disable">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
import SectionCheckReceived from '@/generated/sections/SectionCheckReceived.vue';
import Transaction from '@/extend/classes/Transaction';
import { mimeTypes } from '@/framework/files/helpers/FileTypes';
import Files from '@/generated/classes/Files';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionCheckReceived,
  data() {
    const fileValue = null as File | null;

    return {
      scanned: true,
      fileInputLabel: 'Choisir un fichier',
      progress: false,
      fileValue,
      fileError: false
    };
  },
  computed: {
    acceptedFiles(): string {
      let res = 'pdf'
      mimeTypes.forEach(m => {
        if (m.type == 'pdf') {
          res = m.mime;
        }
      })
      return res;
    },
    file: {
      get(): File | null {
        return this.fileValue;
      },
      set(value: File | null) {
        this.fileValue = value;
        this.fileError = false;
        this.fileInputLabel = 'Choisir un fichier';
      }
    }
  },
  methods: {
    sectionSave(): void {
      this.saveLoading = true;
      if (this.file == null) {
        this.fileInputLabel = 'Requis';
        this.fileError = true;
      }
      if (this.checkFields() && this.file != null) {
        if (this.editTransaction.id > 0) {
          this.progress = true;
          const formData = new FormData()
          formData.append('file', this.file);
          formData.append('service', 'CheckScan');
          formData.append('objId', this.editTransaction.id.toString());
          Files.upload(formData).then(() => {
            Transaction.delivered(this.editTransaction).then((res) => {
              this.saveLoading = false;
              this.closeDialog();
            })
          });
        } else {
          Transaction.delivered(this.editTransaction).then((res) => {
            if (this.file != null) {
              this.progress = true;
              const formData = new FormData()
              formData.append('file', this.file);
              formData.append('service', 'CheckScan');
              formData.append('objId', res.id.toString());
              Files.upload(formData).then(() => {
                this.saveLoading = false;
                this.closeDialog();
              });
            }
            this.saveLoading = false;
            this.closeDialog();
          })
        }
      }
    }
  }
})

</script>
